
import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { Observable } from 'rxjs';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  public isOpen: boolean = false;
  public isLoading: boolean = false;

  public expressListHeader: any = [];
  public expressListData: any = [];
  public listPage: number = 1;
  public listTotalPage: number = 1;

  public savePayloadObject: any = {};
  public savePrevPayloadObject: any = "";
  public expressSaveId: any = "";
  public expressUUid: string = "";
  public isShowDownload: boolean = true;
  public isFormReload: boolean = false;
  public backTrack: string = "";

  public eid: string = "";
  public dataSaving: boolean = false;
  public showDataSaving: boolean = false;
  public isSearchShow:boolean = true


  public updateRelatedFieldEmitter = new EventEmitter<any>();
  public isExpressFormReloadEmitter = new EventEmitter<any>();
  public clientMasterListingSearchChange = new EventEmitter<any>();


  constructor(
    private apiRequest: ApiRequestService,
    public notifier: NotifierService,
    private router: Router
  ) { }

  getListData(query?) {
    this.getListApiCall(query).subscribe((res: any) => {
      if (res && res.status) {
        this.setHeaders(res.headers);
        this.listPage = Number(res.page);
        this.listTotalPage = res.total_page;
        if (this.listPage == 1) {
          this.expressListData = res.data;
        } else {
          this.expressListData = [...this.expressListData, ...res.data];
        }

      } else {
        this.notifier.notify('error', res.message);

      }

    });
  }

  getListApiCall(query?): Observable<any> {
    let opt = {};
    if (query) opt['query'] = query;
    return this.apiRequest.request('GET', '/v2/clientMaster/list', {}, opt);
  }

  setHeaders(header) {
    this.expressListHeader = [];
    Object.keys(header).forEach((key) => {
      this.expressListHeader.push({ 'label': header[key]['label'], 'key': key });
    });
  }

  getClientDetails(uuid, version?: string): Observable<any> {
    return this.apiRequest.request('GET', '/v2/clientMasterData/clientMasterDataDetails/' + uuid);
  }

  getClientRequestDetails(uuid): Observable<any> {
    return this.apiRequest.request('GET', '/v2/clientMaster/clientMasterData/' + uuid);
  }

  getForm(query): Observable<any> {
    let opt = {};
    if (query) opt['query'] = query;
    return this.apiRequest.request('GET', '/v2/clientMaster/list/form', {}, opt);
  }

  getParentClientDetails(body): Observable<any> {
    return this.apiRequest.request('POST', '/v2/clientMasterData/parentClientData', body);
  }

  saveExpressQuotePayload() {
    this.dataSaving = true
    this.showDataSaving = true
    this.saveQuotePayloadApiCall().subscribe((res: any) => {
      if (res && res.status && res.status == 1) {
        this.expressSaveId = res.id || "";
        this.dataSaving = false;
        this.eid = res.eid;
        if (!(this.expressUUid && this.expressUUid != "")) {
          this.expressUUid = res.id;
          this.router.navigate(['/express/request/' + res.id]);
        }
        if (this.isFormReload) {
          this.isFormReload = false;
          // console.log("isExpressFormReloadEmitter for status 1");
          this.isExpressFormReloadEmitter.emit({ "uuid": res.id });
        }
        this.resetQuotePayload();
      } else if (res && res.status && res.status == 2) {
        this.expressSaveId = res.id || "";
        this.dataSaving = false;
        this.updateRelatedFieldEmitter.emit(res.data);
        if (this.isFormReload) {
          this.isFormReload = false;
          // console.log("isExpressFormReloadEmitter for status 2");
          this.isExpressFormReloadEmitter.emit({ "uuid": res.id });
        }
        this.resetQuotePayload();
      } else {
        this.notifier.notify('error', res.message);
        this.dataSaving = false;
        this.showDataSaving = false
      }
    })
  }

  addClientRequest() {
    this.sendClientAddRequest().subscribe((res: any) => {
      if (res && res.status && res.status == 1) {
        this.notifier.notify('success',res.message);
        this.router.navigate([`/client-master/users`]);
      } else {
        this.notifier.notify('error', res.message);
      }
    })
  }

  sendClientAddRequest(): Observable<any> {
    let body = { data: this.savePayloadObject };
    if (this.expressSaveId)body['id'] = this.expressSaveId;
    return this.apiRequest.request('POST', '/v2/clientMaster/saveClientMaster', body);

  }

  

  saveQuotePayloadApiCall(): Observable<any> {
    let body = { data: this.savePayloadObject };
    if (this.expressSaveId) {
      body['id'] = this.expressSaveId;
    }
    return this.apiRequest.request('POST', '/v2/express/saveExpress', body);
  }

  resetQuotePayload() {
    this.savePayloadObject = {};
    this.savePrevPayloadObject = "";
  }




}

